// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_services__card__p3sho {
    width: 30%;
    min-width: 250px;
    max-width: 380px;
    display: flex;
    flex-direction: column;
    gap: 34px;
    padding: 20px;
    border-radius: 8px;
    background-color: var(--neutrals-white);
    border: 1px solid var(--coral-light-blue);
    text-align: start !important;
}

.style_services__card_image__O06JJ {
    width: 100%;
    border-radius: 6px;
}

.style_services__card_image__O06JJ img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.style_services__card__p3sho h4 {
    margin: 0px 0px 10px 0px;
    font-weight: 500;
    font-size: 18px;
}

.style_services__card__p3sho p {
    margin: 0px 0px 10px 0px;
}

/* Team */
.style_team__card__4TzsI {
    width: 30%;
    min-width: 250px;
    max-width: 250px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    border-radius: 8px;
    text-align: start !important;
}

.style_team__card_image__rHBnQ {
    width: 100%;
    height: 280px;
    border-radius: 6px;
}

.style_team__card_image__rHBnQ img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.style_team__card__4TzsI .style_description__pMBAE {
    margin: 10px 0px 0px 0px;
    font-weight: 700;
    font-size: 16px;
}

.style_team__card__4TzsI p {
    margin: 0px 0px 10px 0px;
}

/* Contact */
.style_contact__card__RSssX {
    width: 210px;
    display: flex;
    flex: 1 1;
    padding: 10px 0px;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
}

.style_contact__card_image__MwFKW {
    width: 126px;
    height: 126px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-bottom: 35px;
    background-color: var(--white);
}

.style_contact__card_description__xHNop p {
    margin: 0;
}

.style_contact__card_description__xHNop p:first-of-type {
    font-weight: 700;
}

.style_contact__card_description__xHNop p:last-of-type {
    font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/cards/style.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,yCAAyC;IACzC,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,SAAS;AACT;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,YAAY;AACZ;IACI,YAAY;IACZ,aAAa;IACb,SAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".services__card {\n    width: 30%;\n    min-width: 250px;\n    max-width: 380px;\n    display: flex;\n    flex-direction: column;\n    gap: 34px;\n    padding: 20px;\n    border-radius: 8px;\n    background-color: var(--neutrals-white);\n    border: 1px solid var(--coral-light-blue);\n    text-align: start !important;\n}\n\n.services__card_image {\n    width: 100%;\n    border-radius: 6px;\n}\n\n.services__card_image img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.services__card h4 {\n    margin: 0px 0px 10px 0px;\n    font-weight: 500;\n    font-size: 18px;\n}\n\n.services__card p {\n    margin: 0px 0px 10px 0px;\n}\n\n/* Team */\n.team__card {\n    width: 30%;\n    min-width: 250px;\n    max-width: 250px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    border-radius: 8px;\n    text-align: start !important;\n}\n\n.team__card_image {\n    width: 100%;\n    height: 280px;\n    border-radius: 6px;\n}\n\n.team__card_image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.team__card .description {\n    margin: 10px 0px 0px 0px;\n    font-weight: 700;\n    font-size: 16px;\n}\n\n.team__card p {\n    margin: 0px 0px 10px 0px;\n}\n\n/* Contact */\n.contact__card {\n    width: 210px;\n    display: flex;\n    flex: 1;\n    padding: 10px 0px;\n    align-items: center;\n    justify-content: flex-start;\n    flex-direction: column;\n}\n\n.contact__card_image {\n    width: 126px;\n    height: 126px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    margin-bottom: 35px;\n    background-color: var(--white);\n}\n\n.contact__card_description p {\n    margin: 0;\n}\n\n.contact__card_description p:first-of-type {\n    font-weight: 700;\n}\n\n.contact__card_description p:last-of-type {\n    font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"services__card": `style_services__card__p3sho`,
	"services__card_image": `style_services__card_image__O06JJ`,
	"team__card": `style_team__card__4TzsI`,
	"team__card_image": `style_team__card_image__rHBnQ`,
	"description": `style_description__pMBAE`,
	"contact__card": `style_contact__card__RSssX`,
	"contact__card_image": `style_contact__card_image__MwFKW`,
	"contact__card_description": `style_contact__card_description__xHNop`
};
export default ___CSS_LOADER_EXPORT___;
